/**
 * Strip cloudnariy prefix from an image URL and return the original URL
 *
 * @param {string} url URL to strip the cloudinary prefix from
 */
export default function extractImageUrl(url) {
  const cloudinaryRegex = /.*?res\.cloudinary\.com\/(?:[^/]+\/){4}/;
  const httpRegex = /^https?:/;

  return url.replace(cloudinaryRegex, "").replace(httpRegex, "https:");
}
